const styles = {
  root: {
    background: 'white',
    boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.05)',
    boxSizing: 'border-box',
    padding: '30px',
    width: '100%',
  },
};

export default styles;
